import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/plugins/vuelidate';
import '@/plugins/vuemask';
import '@/plugins/vuemoney';
import '@/plugins/vuealertme';
import { uuidv4, existsProp } from "./services/utils";
Vue.config.productionTip = false
Vue.use(require('vue-moment'));
new Vue({
  router,
  store,
  vuetify,
  data () {
    return {
      hashTable: {},
      event: null,
      monitorStatusCam: null,
      event_name_busca: 'monitoramento-status-cam',
      event_name_id: '',
      event_name_time: 180000,
      callbackError: null
    }
  },
  methods: {
    getDate () {
      let datetime = new Date();
      let split = datetime.toISOString().split("T");
      return split[0] + " " + split[1].split(".")[0];
    },
    uuid () {
      return uuidv4();
    },
    buscaStatusCam () {
      this.event_name_id = this.uuid()
      this.createMessageServer(this.event_name_busca, {
        hostId: this.$store.getters.hostActive,
        channel: 1,
        msgId: this.event_name_id,
        datetime: this.getDate(),
        value: { operation: 90, data: "status" }
      });
      console.log('--------- BUSCANDO CAMERA ----------------')
      this.$root.$on(this.event_name_busca, obj => {
        this.$store.dispatch("setListStatusCams", [...obj.result.cameras]);
        this.initMonitorStatusCam()
      });
    },
    initMonitorStatusCam () {
      if (this.monitorStatusCam == null) {
        this.monitorStatusCam = setTimeout(() => {
          clearTimeout(this.monitorStatusCam)
          this.monitorStatusCam = null
          this.buscaStatusCam()
        }, this.event_name_time)
      }
    },
    stopMonitorStatusCam () {
      if (this.monitorStatusCam != null) {
        console.log("Parando busca de cameras");
        this.$off(this.event_name_busca);
        this.deleteHashTable(this.event_name_id)
        clearTimeout(this.monitorStatusCam)
        this.monitorStatusCam = null
      }
    },
    resetTemporizadorUser(){
      this.$emit('resetDialogOnline')
    },
    stopMessages () {
      this.clearHashTable()
      this.abortFindMessageServer()
      this.stopMonitorStatusCam()
    },
    addCallBackError (callback) {
      this.callbackError = callback
    },
    addHashTable (id, event) {
      this.hashTable[id] = event
    },
    deleteHashTable (hash) {
      delete this.hashTable[hash]
    },
    clearHashTable () {
      this.hashTable = {}
    },
    abortFindMessageServer () {
      if (this.event != null && this.event != undefined) {
        clearTimeout(this.event)
        this.event = null
      }
    },
    deleteAllMessageServer () {
      this.$alertme
        .listMessageChannelNoLoad({ hostId: this.$alertme.getHostIdUrl(this.$route) })
        .then(
          res => {
            if (res.data.value) {
              let listId = [];
              res.data.value.forEach(item => {
                listId.push(item.msgId);
              });
              if (listId.length > 0) {
                let data = {
                  hostId: this.$store.getters.hostActive,
                  channel: 2,
                  msgId: listId
                };
                this.$alertme.deleteMessageChannelNoLoad(data).then(() => { });
              }
            }
          },
          e => {
            this.$store.dispatch("setMsgError", e.message);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        );
    },
    createMessageServer (event, content, load, callback) {
      this.$alertme.sendMessageChannelNoLoad(content).then(
        res => {
          // if (res.data.message == "ok") {
          this.addHashTable(content.msgId, event)
          this.addFindMessageServer(3000);
          console.log('tabela de eventos', this.hashTable);
          console.log(res);
          // }
          if (typeof callback == Function) {
            callback(res)
          }
        },
        e => {
          console.log('erro ao criar mensagem')
          this.$store.dispatch("setMsgError", e.message);
          this.$store.dispatch("setDisplayMsgErr", true);
        }
      )
        .catch(e => {
          console.log('Cath criador de mensagem')
          console.log(e);
        });
    },
    addFindMessageServer (time) {
      console.log('Tentando salvar busca de mensagem, valor eventTimeOut=', this.event);

      if (this.event == null || this.event == undefined) {
        console.log('ativa busca por mensagem ');
        this.event = setTimeout(() => this.checkMessageServer(), time ? time : 10000);
      }
    },
    checkMessageServer () {
      let data = {
        hostId: this.$store.getters.hostActive,
        channel: 2
      };
      this.event = null;
      this.$alertme.getMessageChannelNoLoad(data).then(
        res => {
          if (res.data.message == 'eof') {
            this.addFindMessageServer(3000)
            return
          }
          this.emitEvent(res.data.msgId, res.data.value);
        },
        e => {
          this.addFindMessageServer(3000);
          if (typeof this.callbackError == Function) {
            this.callbackError(e)
          }
          this.$store.dispatch("setMsgError", e.message);
          this.$store.dispatch("setDisplayMsgErr", true);
        }
      );
    },
    emitEvent (id, content) {
      let data_delete = {
        hostId: this.$store.getters.hostActive,
        channel: 2,
        msgId: [id]
      };
      if (id == undefined || id == null || id.length <= 0) {
        return
      }
      this.$alertme.deleteMessageChannelNoLoad(data_delete)
        .then((res) => {
          if (res.data.message != 'ok') {
            this.$store.dispatch(
              "setMsgError",
              "Não foi possível realizar operação!"
            );
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        },
          e => {
            this.$store.dispatch("setMsgError", e.message);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
        );
      this.addFindMessageServer(3000)
      if (existsProp(this.hashTable, id)) {
        this.$emit(this.hashTable[id], content)
        this.$off(this.hashTable[id])
        this.deleteHashTable(id)
      }
    },
  },
  render: h => h(App)
}).$mount('#app')
